import { render } from "./EmpresaTabela.vue?vue&type=template&id=306f66dd&scoped=true"
import script from "./EmpresaTabela.vue?vue&type=script&lang=js"
export * from "./EmpresaTabela.vue?vue&type=script&lang=js"

import "./EmpresaTabela.vue?vue&type=style&index=0&id=306f66dd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306f66dd"]])

export default __exports__